import { useQuery } from "react-query";
import { getCompletedInvoices } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetCompletedInvoices = () => {
  return useQuery("GetCompletedInvoices", getCompletedInvoices, {
    refetchOnWindowFocus: false,
  });
};
